/* eslint-disable no-useless-constructor */
import Axios from "./axios.service";

export class AgentService {
  constructor() {}
  static async listPartnerAgentBranches(page = 1, size = 259) {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/pay-centre-management/list-all-pay-centre?page=${page}&size=${size}`,
    });
  }

  static async listApproveDisapproveAgents() {
    return Axios({
      method: "GET",
      url: `web-services/api/v6/services/admin/pay-centre-management/list-all-pay-centre-waiting`,
    });
  }

  static async approveAgentById(agentId) {
    return Axios({
      method: "PUT",
      url: `web-services/api/v6/services/admin/pay-centre-management/approve-agent/${agentId}`,
    });
  }

  static async disapproveAgentById(agentId) {
    return Axios({
      method: "PUT",
      url: `web-services/api/v6/services/admin/pay-centre-management/disapprove-agent/${agentId}`,
    });
  }

  static async addNewAgent(payload) {
    return Axios({
      method: "POST",
      url: `web-services/api/v6/services/admin/pay-centre-management/add-internal-pay-centre`,
      data: payload,
    });
  }
}
